// !!! COOKIES
// mx http://sportapi-sb.netbet.com.mx/cookie/set/netbet_global_staging
// others http://sportapi-sb.netbet.de/cookie/set/netbet_global_staging

// stage links:
//http://loto-staging.netbet.ro
//http://lotto-staging.netbet.com

// https://www.cnbfbtlotto.com/stage/netbetcom/Lottery/frontConfig.php
// https://www.cnbfbtlotto.com/stage/netbetde/Lottery/frontConfig.php

//new stage netbet ro
// https://www.cnbfbtlotto.com/stage/netbetro/Lottery/launch?currency=RON&providergameid=international_lotteries&licenseeid=354&language=ro&isbgameid=1043&isbskinid=3258&lobbyurl=https%3A%2F%2Floto.netbet.ro%2F%3FparentIframe%3D1&country=RO&mode=fun&launchercode=isb_netbetcom-prod&extra=mobile&operator=NBTRO&allow_full_screen=true

var ruta, rutaVizual
rutaVizual = {
    dev: {
        int: "https://www.cnbfbtlotto.com/stage/gui/netbetcom/lottery/visual/v0.02/index.html",
        de: "https://www.cnbfbtlotto.com/stage/gui/netbetcom/lottery/visual/v0.02/index.html",
        fi: "https://www.cnbfbtlotto.com/stage/gui/netbetcom/lottery/visual/v0.02/index.html",
        mx: "https://www.cnbfbtlotto.com/stage/gui/netbetcom/lottery/visual/v0.02/index.html", //mexic
        ie: "https://www.cnbfbtlotto.com/stage/gui/netbetcom/lottery/visual/v0.02/index.html",
        ro: "https://www.cnbfbtlotto.com/stage/gui/netbetcom/lottery/visual/v0.02/index.html",
    },
    stage: {
        int: "https://www.cnbfbtlotto.com/stage/netbetcom/Lottery/visual_launch",
        de: "https://www.cnbfbtlotto.com/stage/netbetde/Lottery/visual_launch",
        fi: "https://www.cnbfbtlotto.com/stage/netbetfi/Lottery/visual_launch",
        mx: 'https://www.cnbfbtlotto.com/stage/netbetcommx/Lottery/visual_launch', //mexic
        ie: 'https://www.cnbfbtlotto.com/stage/netbetie/Lottery/visual_launch',
        ro: 'https://www.cnbfbtlotto.com/stage/netbetro/Lottery/visual_launch',
    },
    prod: {
        int: "https://www.cnbfbtlotto.com/netbetcom/Lottery/visual_launch",
        de: "https://www.cnbfbtlotto.com/netbetde/Lottery/visual_launch",
        fi: "https://www.cnbfbtlotto.com/netbetfi/Lottery/visual_launch",
        mx: 'https://www.cnbfbtlotto.com/netbetcommx/Lottery/visual_launch', //mexic
        ie: 'https://www.cnbfbtlotto.com/netbetie/Lottery/visual_launch',
        ro: 'https://www.cnbfbtlotto.com/netbetro/Lottery/visual_launch',
    },
}
ruta = {
    dev: {
        int: "https://www.cfvbfbtlotto.com/online/netbetcom/Lottery/",
        de: "https://www.cfvbfbtlotto.com/online/netbetde/Lottery/",
        fi: "https://www.cfvbfbtlotto.com/online/netbetfi/Lottery/",
        mx: 'https://www.cfvbfbtlotto.com/online/netbetcommx/Lottery/', //mexic
        ie: 'https://www.cfvbfbtlotto.com/online/netbetie/Lottery/',
        ro: 'https://www.cfvbfbtlotto.com/online/netbetro/Lottery/',
    },
    stage: {
        int: "https://www.cnbfbtlotto.com/stage/netbetcom/Lottery/",
        // https://www.cnbfbtlotto.com/stage/gui/netbetcom/lottery/upload_page/upload.php
        de: "https://www.cnbfbtlotto.com/stage/netbetde/Lottery/",
        // https://www.cnbfbtlotto.com/stage/gui/netbetde/lottery/upload_page/upload.php
        fi: "https://www.cnbfbtlotto.com/stage/netbetfi/Lottery/",
        // https://www.cnbfbtlotto.com/stage/gui/netbetfi/lottery/upload_page/upload.php
        mx: 'https://www.cnbfbtlotto.com/stage/netbetcommx/Lottery/',
        // https://www.cnbfbtlotto.com/stage/gui/netbetcommx/lottery/upload_page/upload.php
        ie: 'https://www.cnbfbtlotto.com/stage/netbetie/Lottery/',
        // https://www.cnbfbtlotto.com/stage/gui/netbetie/lottery/upload_page/upload.php
        ro: 'https://www.cnbfbtlotto.com/stage/netbetro/Lottery/',
        // https://www.cnbfbtlotto.com/stage/gui/netbetro/lottery/upload_page/upload.php
    },
    prod: {
        int: "https://www.cnbfbtlotto.com/netbetcom/Lottery/",
        // https://www.cnbfbtlotto.com/gui/netbetcom/lottery/upload_page/upload.php
        de: "https://www.cnbfbtlotto.com/netbetde/Lottery/",
        // https://www.cnbfbtlotto.com/gui/netbetde/lottery/upload_page/upload.php
        fi: "https://www.cnbfbtlotto.com/netbetfi/Lottery/",
        // https://www.cnbfbtlotto.com/gui/netbetfi/lottery/upload_page/upload.php
        mx: 'https://www.cnbfbtlotto.com/netbetcommx/Lottery/',
        // https://www.cnbfbtlotto.com/gui/netbetcommx/lottery/upload_page/upload.php
        ie: 'https://www.cnbfbtlotto.com/netbetie/Lottery/',
        // https://www.cnbfbtlotto.com/gui/netbetie/lottery/upload_page/upload.php
        ro: 'https://www.cnbfbtlotto.com/netbetro/Lottery/',
        // https://www.cnbfbtlotto.com/gui/netbetro/lottery/upload_page/upload.php
    },
}
let lang = {
    int: 'en',
    de: 'de',
    fi: 'fi',
    mx: 'es',
    ie: 'en',
    ro: 'ro',
}
var options = {
    colStLotteries: 'dropDown', // list / dropDown
    steaguri: 'rotunde', // rotunde / patrate
    nrTabs: 5,
    colMid: 'Mid1ConNr', // Mid2Col / MidListDD / Mid1ConNr
    systemType: 'multy', // unique / multy
    live: true,
    topWiners: true,
    future: true,
    randomNumbers: true,
    paytable: true,
    slider: false,
    oficialLinks: true,
    widgetPromo: false,
    mainLang: lang.ro,
    rutaVizual: rutaVizual.prod.ro,
    ruta: ruta.prod.ro,
}

export default function (state = options, action) {
    return state;
}

